import { DialogComponent } from '@dialog/dialog.component';
import { Subscription, of, BehaviorSubject } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ICompany } from '@company/company.structures';
import { ExceptionService } from '@exceptions-service';
import {
  ICheckListBoard, ICheckListParams, IUserCompany, IDialogData,
  IErrorResponse, IUser, User, IDialogSearchParams
} from '@interfaces';
import { Role } from '@models';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';

import { UserService } from '@user/user.service';
import { FormControlService } from '@base/form-controls.service';
import { AppService } from '@base/app.service';
import { ROLES, COMPANY, EMPTY, UNDEFINED, getReferencedValue } from '@utils';
import * as _ from 'lodash';
import { CompanyService } from '@base/company/company.service';
import { environment } from '@environments/environment';

interface IRelatedCompany {
  id: number;
  related: {
    status: boolean;
    disabled: boolean;
  };
  active: {
    status: boolean;
    disabled: boolean;
  };
}

@Component({
  selector: 'app-user',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.sass']
})
export class UserFormComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private _companies: IRelatedCompany[] = [];
  private TableauSiteRoles = environment.TableauSiteRoles;
  private previousTableauRole = null;
  private tableauRoleSubscription: Subscription = null;

  first_name = new FormControl(null, [
    Validators.required, Validators.maxLength(25),
    Validators.pattern('^[A-Za-z\ \ñ]+'),
  ]);
  last_name = new FormControl(null, [
    Validators.required, Validators.maxLength(25),
    Validators.pattern('^[A-Za-z\ \ñ]+'),
  ]);
  email = new FormControl(null, [Validators.required, Validators.maxLength(45), Validators.email]);
  tableau_license_type = new FormControl(null, [Validators.required]);
  userForm: FormGroup;
  user: IUser;
  showSpinner = false;
  edit = false;
  selectedRole: Role;
  strAction = 'Agregar';
  checkListData: ICheckListBoard;
  showCompanyPanel = false;
  userMemberships = [];

  private _checkListInfo: Partial<ICheckListParams> = {
    icon: 'business',
    gettingData: true,
    title: 'Empresas',
    footer: 'Empresas Seleccionadas: ',
    description: 'lista de empresas asociadas',
    relatedName: 'empresa',
    expanded: true,
    searchButton: true,
    autoActivate: false,
    searchParams: {
      singleName: 'empresa',
      filter: COMPANY,
      searchKey: null,
      exclude: [],
      source: [],
    } as IDialogSearchParams
  };

  gettingInfo = false;
  companies: ICompany[];
  users: IUser[];
  currentUserSession: IUser = EMPTY;
  companiesCollection = new BehaviorSubject<any>([]);
  ROLES = ROLES;

  constructor(
    private fb: FormBuilder,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    public location: Location,
    private userService: UserService,
    private exceptionService: ExceptionService,
    private formControlService: FormControlService,
    public mainService: AppService,
    private companyService: CompanyService,
  ) {
    this.subscriptions = [];
    this.companies = [];
    this.users = [];
    this.selectedRole = new Role();
    this.checkListData = {
      info: this._checkListInfo,
      data: [],
    };
    this.user = EMPTY;
    this.userForm = this.fb.group({
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      tableau_license_type: this.tableau_license_type,
    });

    const userSelectedSubscription = this.userService.userSelectedChanged().subscribe((user: IUser) => {
      const auxUser = (typeof user !== UNDEFINED) ? user : EMPTY;
      this.user = auxUser;
      this.showUserInfo();
    });

    const usersSubscription = this.userService.observeUsers().subscribe(
      (users: IUser[][]) => this.users = users[this.selectedRole.code]
    );

    const companiesSubscription = this.companyService.observeCompanies().subscribe(
      (companies: ICompany[]) => this.companies = companies
    );

    const sessionSubs = this.mainService.getCurrentUser().subscribe(this.checkPermissions);
    this.tableauRoleSubscription = this.tableau_license_type.valueChanges.subscribe(this.validateTableauRole);

    this.subscriptions = [...this.subscriptions, userSelectedSubscription, companiesSubscription,
      usersSubscription, sessionSubs, this.tableauRoleSubscription];
  }

  ngOnInit() {
    let idUser: number = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    idUser = (isNaN(parseFloat(idUser + ''))) ? undefined : idUser;

    // en caso de estar editando un usuario...
    if (typeof idUser !== UNDEFINED) {
      this.getUser(idUser);

    // esta agregando un usuario nuevo
    } else if (typeof idUser === UNDEFINED) {
      this.selectedRole = this.userService.selectedRole;

      if (typeof this.selectedRole !== UNDEFINED) {
        this.loadCompaniesData();
      } else {
        this.selectedRole = EMPTY;
        this.router.navigate(['/home']);
      }
    }
  }

  ngOnDestroy() {
    localStorage.removeItem('temp_url');
    this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe());
  }

  private checkPermissions = (session: IUser) => {
    // const formControlNames = ['first_name', 'last_name', ];
    // let denyEditing = true;
    this.currentUserSession = session;
    // if (session !== EMPTY) {
    //   const role: IRole = session.role;
    //   denyEditing = (role.code !== ROLES.ADMIN && role.code !== ROLES.LEADER);
    // }

    // if (denyEditing) {
    //   formControlNames.map(control => this.userForm.controls[control].disable());
    // }
  }

  private setTableauLicenseType() {
    const isAdmin = (this.selectedRole.code === ROLES.ADMIN);
    const isCustomer = (this.selectedRole.code === ROLES.CUSTOMER);

    // inicializar licencia con UNLICENSED...
    if (this.user.tableau_license_type === EMPTY) {
      this.user.tableau_license_type = this.TableauSiteRoles.Unlicensed;
    }

    if (!isAdmin) {
      if (isCustomer) {
        // this.user.tableau_license_type = this.TableauSiteRoles.Viewer;
      } else {
        // es Lider o Analista...
      }
    } else if (isAdmin) {
      this.user.tableau_license_type = this.TableauSiteRoles.Unlicensed;
    }
    this.previousTableauRole = this.user.tableau_license_type;
  }

  private showUserInfo() {
    if (this.user !== EMPTY) {
      let memberships = [];
      this.edit = true;
      this.email.disable();
      this.selectedRole = this.user.role;
      this.setTableauLicenseType();
      this.userService.selectedRole = this.selectedRole;
      this.userForm.patchValue({
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        tableau_license_type: this.user.tableau_license_type,
      });
      memberships = (this.user.memberships.length > 0) ? this.user.memberships : [];
      this.groupsInfoAdapter(_.groupBy(memberships, 'group.company'));
      this.loadCompaniesData();
    }
  }

  private companiesAdapter() {
    // this._companies tiene la estructura como aparecen las empresas en el listado...
    const auxUser = {...this.user};
    let currentCompanies: object[] = auxUser.companies;

    // prepara los datos de empresas...
    this._companies.map((company: IRelatedCompany) => {
      const objIndex = currentCompanies.findIndex(item => item['company']['id'] === company.id);

      if (objIndex >= 0) {
        currentCompanies[objIndex]['active'] = company.active.status;
        currentCompanies[objIndex]['related'] = company.related.status;

      // el analista o el cliente no tiene aun empresas asociadas...
      } else {
        const newElement = {
          id: 0,
          company: {id: company.id},
          active: company.active.status,
          related: company.related.status
        };
        currentCompanies = [...currentCompanies, newElement];
      }
      return null;
    });

    return currentCompanies;
  }

  private validateTableauRole = (newVal: string) => {
    const applyValidation = (this.selectedRole.code === ROLES.ANALYST || this.selectedRole.code === ROLES.CUSTOMER);

    if (newVal === this.TableauSiteRoles.Unlicensed && applyValidation) {
      const auxCompanies = (getReferencedValue(this.user, 'companies') !== null) ? [...this.user.companies] : [];
      const newCompaniesCount = this._companies.length;

      if (auxCompanies.length || newCompaniesCount > 0) {
        let strMessage = 'Esta intentando cambiar el tipo de Licencia, se eliminará la cuenta en <i><u>Tableau Server</u></i> ';
        if (this.selectedRole.code === ROLES.CUSTOMER) {
          strMessage += ', asociaciones con <strong><u>Grupos</u></strong> a los que pertenece ';
        }
        strMessage += 'y permisos a todos los <i><u>Reportes</u></i> que tiene acceso.<br>';
        const params: IDialogData = {
          strQuestion: `${strMessage}<strong>¿Confirma el cambio de la licencia?</strong>`,
          strAccept: 'Aceptar',
          strCancel: 'Cancelar',
          buttonColor: 'warn',
        };
        const dialogRef = this.dialog.open(DialogComponent, {
          width: '400px',
          data: params,
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe((deleteLicense: boolean) => {
          if (deleteLicense) {
            this.previousTableauRole = newVal;
          } else {
            this.tableau_license_type.setValue(this.previousTableauRole);
          }
        });
      } else {
        this.previousTableauRole = newVal;
      }
    } else {
      this.previousTableauRole = newVal;
    }
  }

  register() {
    this.showSpinner = true;
    this.tableauRoleSubscription.unsubscribe();
    this.userForm.disable();
    this.user = (!this.edit) ? new User(this.userForm.value) : { ...this.user, ...this.userForm.value, };
    this.user.companies = this.companiesAdapter();
    this.user.email = this.user.email.toLowerCase();
    this.user.role = this.selectedRole;
    const observable = (this.edit) ? this.userService.update(this.user) : this.userService.register(this.user);

    // const requests = of(
    //   observable,
    // );
    // const totalRequests = requests.forEach.length;
    // const listeners = requests.pipe(concatMap(obs => obs));

    // let listenerCount = 0;
    observable.subscribe(
      (response) => {
        // listenerCount++;
        // this.showSpinner = (totalRequests !== listenerCount);
        const queryParams = {
          search: this.selectedRole.code,
          ordering: ['-updated_at', ],
        };
        let filter = null;
        if (this.selectedRole.code === ROLES.ANALYST) {
          delete queryParams['search'];
          filter = {user: this.currentUserSession, endpoint: ROLES.CUSTOMER};
        }
        this.userService.getUsers(queryParams, this.selectedRole.code, filter);
        this.showSpinner = false;
        this.userForm.enable();
        this.openSnackBar('Usuario guardado exitosamente.', 'info');
        this.location.back();
      },
      (e: HttpErrorResponse) => {
        this.userForm.enable();
        this.showSpinner = false;
        const error: IErrorResponse = this.exceptionService.errorHandling(e);
        this.openSnackBar(error.message, error.title);
      },
     );
  }

  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }

  groupsInfoAdapter(obj: object) {
    let memberships: any[] = [];

    if (Object.keys(obj).length) {
      for (const key of Object.keys(obj)) {
        if (key !== UNDEFINED) {
          memberships.push({
            company: key,
            groups: obj[key]
          });
        } else {
          // no necesita adaptar nuevamente los grupos...
          memberships = obj['undefined'] as [];
          break;
        }
      }
    }
    // this.user.memberships = memberships;
    this.userMemberships = memberships;
  }

  getUser(id: number) {
    this.edit = true;
    this.strAction = 'Editar';

    if (this.user === EMPTY) {
      this.gettingInfo = true;
      // se esta recargando la pagina, hay que obtener la info desde la api...
      const userSubscription: Subscription = this.userService.getUser(id).subscribe(
        (user: IUser) => {
          this.userService.setUser(user);
          this.gettingInfo = false;
        },
        (err: HttpErrorResponse) => {
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
          this.openSnackBar(error.message, error.title);
        }
      );

      this.subscriptions = [...this.subscriptions, userSubscription];
    }
  }

  getRelatedInfo() {
    if (typeof this.user.companies !== UNDEFINED) {
      this._companies = [];
      const companies = [...this.user.companies];
      let companiesRelated = [];

      companies.map((element: IUserCompany) => {
        const company: Partial<ICompany> = element.company;
        const active = element.active;

        const newRow = {
          id: company.id,
          name: company.name,
          related: {
            status: true,
            disabled: false,
          },
          active: {
            status: active,
            disabled: false,
          },
        };
        companiesRelated = [...companiesRelated, newRow];

        // inicializar la lista de empresas relacionadas con el usuario...
        const auxNewRow = {...newRow};
        delete auxNewRow.name;
        const relatedCompanyElement: IRelatedCompany = auxNewRow;
        this._companies = [...this._companies, relatedCompanyElement];

        return null;
      });

      this.checkListData.data = companiesRelated;
      this.checkListData.info.gettingData = false;
      this.companiesCollection.next(companiesRelated);
    }
  }

  loadCompaniesData() {
    const loadCompanies = (this.selectedRole.code === ROLES.CUSTOMER || this.selectedRole.code === ROLES.ANALYST);

    if (loadCompanies) {
      this.showCompanyPanel = true;
      if (this.user !== EMPTY && this.edit) {
        this.getRelatedInfo();
      } else {
        this.checkListData.info.gettingData = false;
      }
    }
  }

  updateCheckListSelection(newList: any) {
    this._companies = newList;
    let validCompanies = false;

    if (newList.length > 0) {
      const objIndex = newList.findIndex(((obj: any) => obj.related.status === true));
      validCompanies = (objIndex >= 0);
    }
  }

  deleteUser(user: IUser): void {
    const params: IDialogData = {
      strQuestion: `¿Confirma la eliminación de ${user.first_name} ${user.last_name}?`,
      strAccept: 'Aceptar',
      strCancel: 'Cancelar',
      buttonColor: 'warn',
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((deleteUser: boolean) => {
      if (deleteUser) {
        this.gettingInfo = true;
        this.showSpinner = true;

        const requests = of(
          this.userService.delete(user),
        );
        const totalRequests = requests.forEach.length;
        const listeners = requests.pipe(concatMap(obs => obs));

        listeners.subscribe(
          (response) => {
            //
          },
          (e: HttpErrorResponse) => {
            this.gettingInfo = false;
            this.showSpinner = false;
            const err: IErrorResponse = this.exceptionService.errorHandling(e);
            this.openSnackBar(err.title, err.message);
          },
          () => {
            this.userService.getUsers(
              {search: this.selectedRole.code, ordering: ['-updated_at', ], },
              this.selectedRole.code
            );
            this.openSnackBar('Usuario borrado de la plataforma.', 'info');
            this.location.back();
          }
         );
      }
    });
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }
}
